__turbopack_context__.v({
  "assetCountColumn": "FolderTable-module__MMysAW__assetCountColumn",
  "avatar": "FolderTable-module__MMysAW__avatar",
  "caretIcon": "FolderTable-module__MMysAW__caretIcon",
  "folderTable": "FolderTable-module__MMysAW__folderTable",
  "iconButtonCell": "FolderTable-module__MMysAW__iconButtonCell",
});
